import { gql } from "@apollo/client";

export const typeDef = gql`
  type HtmlSnippet {
    id: Int
    content: String
    style: String
    javascript: String
  }

  type Query {
    htmlSnippet(id: Int, idKey: String): HtmlSnippet
  }
`;

export const resolvers = {
  Query: {
    htmlSnippet: async (_parent, { id, idKey }, { dataSources }) => {
      const res = await dataSources.htmlSnippet.getHtmlSnippet(id, idKey);
      return res;
    },
  },
};
